import React from 'react';
import EventPageTemplate from './EventPageTemplate';
import { eventData } from '../data/eventContent';

const FestivalsPage: React.FC = () => {
  return <EventPageTemplate {...eventData.festivals} />;
};

export default FestivalsPage;